import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';

import { canceledLoadSpraySubmission, requestLoadSpraySubmission } from 'services/spraySubmission/actions';
import { SpraySubmissionId } from 'services/spraySubmissions/types';

interface OwnProps {
    spraySubmissionId: SpraySubmissionId;
}

interface DispatchProps {
    requestLoadSpraySubmission: typeof requestLoadSpraySubmission;
    canceledLoadSpraySubmission: typeof canceledLoadSpraySubmission;
}

type Props = OwnProps & DispatchProps;

export class SpraySubmissionRequestComponent extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;
        props.requestLoadSpraySubmission(props.spraySubmissionId);
    }

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (!isEqual(prevProps.spraySubmissionId, props.spraySubmissionId)) {
            props.requestLoadSpraySubmission(props.spraySubmissionId);
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.canceledLoadSpraySubmission();
    }

    render(): null {
        return null;
    }
}

export default connect(
    null,
    {
        requestLoadSpraySubmission,
        canceledLoadSpraySubmission
    }
)(SpraySubmissionRequestComponent);
